import { render, staticRenderFns } from "./FormDefault.vue?vue&type=template&id=2525b140&"
import script from "./FormDefault.vue?vue&type=script&lang=js&"
export * from "./FormDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports